export * from './collapse';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/md2/collapse/index.js
// module id = 854
// module chunks = 3